/**
 * 邮箱管理器
 * 负责管理邮箱信息，提供获取、更新等功能
 * @author 杨俊朗
 */
export class IamLoginMethodManager {
  private static instance: IamLoginMethodManager;
  private store: 1 | 2 = 2;

  private constructor() {}

  // 单例模式
  public static getInstance(): IamLoginMethodManager {
    if (!IamLoginMethodManager.instance) {
      IamLoginMethodManager.instance = new IamLoginMethodManager();
    }
    return IamLoginMethodManager.instance;
  }

  // 更新邮箱信息
  public update(value: 1 | 2): void {
    console.log("update login method store", value, import.meta.url);
    this.store = value;
  }

  // 获取邮箱信息
  public get(): 1 | 2 {
    return this.store;
  }

  // 清除邮箱信息
  public clear(): void {
    this.update(2);
  }
}

export const iamLoginMethodManager = IamLoginMethodManager.getInstance();
